import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from './UserRoleProvider';

// Applied Epic self-service. Access is a per-user grant (`self_service_access` on the user record)
// and nothing else — not a role, and not admin, who can set the flag but has to set it for
// themselves like anyone else. The API enforces the same rule as the 'SelfService' capability, so
// this guard is about not showing someone a page that would only 403; it is not the security
// boundary.
const SelfServiceRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { canUseSelfService, isLoading, rolesUnknown } = useUserRole();

  // The profile lookup failed, so we don't know whether access was granted — say so rather than
  // redirect, which would read as a denial to someone who does have it.
  if (rolesUnknown) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message">
            <p>We couldn't confirm your access. Please reload the page or sign in again.</p>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message"><p>Checking access...</p></div>
        </div>
      </div>
    );
  }

  if (!canUseSelfService) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default SelfServiceRoute;
